import { Component, OnInit, Optional, SkipSelf } from '@angular/core';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { DrrCcdDeviceService } from '../technical-data/technical-data.service';
import { DrrCcdDeviceApplicationDto } from '../technical-data/technical-data.domain';
import { DrrCcdDataStore } from '../drr-ccd-data.store';

@Component({
  selector: 'app-drr-ccd-data-context',
  templateUrl: './drr-ccd-data-context.component.html',
  styleUrls: ['./drr-ccd-data-context.component.scss'],
})
export class DrrCcdDataContextComponent extends DestroyableComponent implements OnInit {
  applicationId: number;
  isLoading: boolean;

  constructor(
    localStorage: LocalStorageService,
    @Optional() @SkipSelf() parentComponent: DrrCcdDataContextComponent,
    private drrCcdApplicationService: DrrCcdDeviceService,
    public store: DrrCcdDataStore
  ) {
    super();
    if (!parentComponent) {
      this.applicationId = parseInt(localStorage.getItem('application_id') ?? '0');
      this.loadData();
    }
  }

  ngOnInit(): void {}

  loadData() {
    if (this.applicationId === 0) return;

    this.isLoading = true;
    this.store.setApplicationDto(null);
    this.preventLeak(this.drrCcdApplicationService.getCcdDeviceApplication(this.applicationId)).subscribe(
      (response: DrrCcdDeviceApplicationDto) => {
        this.isLoading = false;
        this.store.setApplicationDto(response);
      },
      error => (this.isLoading = false)
    );
  }
}
